"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unhoverRestaurantCard = exports.hoverRestaurantCard = exports.getRestaurantCard = void 0;
const getRestaurantCard = (restaurant) => {
    if (!restaurant) {
        return null;
    }
    return document.getElementById(`restaurant-card-${restaurant.retailLocationId}`);
};
exports.getRestaurantCard = getRestaurantCard;
const hoverRestaurantCard = (restaurant, scrollIntoView = true) => {
    const restaurantCard = (0, exports.getRestaurantCard)(restaurant);
    if (!restaurantCard) {
        return;
    }
    if (scrollIntoView) {
        restaurantCard.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }
    restaurantCard.classList.add("-hovered");
};
exports.hoverRestaurantCard = hoverRestaurantCard;
const unhoverRestaurantCard = (restaurant) => {
    const restaurantCard = (0, exports.getRestaurantCard)(restaurant);
    if (!restaurantCard) {
        return;
    }
    restaurantCard.classList.remove("-hovered");
};
exports.unhoverRestaurantCard = unhoverRestaurantCard;
//# sourceMappingURL=restaurantCard.js.map